import styles from './Popup.styl';
import React from "react";

function Popup(props) {

	const {warningText, onClick, type} = props
	let background={backgroundColor: '#FFCC3F'}
	if(type){
		if(type==='itk'){
			background={backgroundColor: '#76d750'}
		}
	}
	return (
		<div id="warning" className={styles.overlay} onClick={onClick}>
			<div id="warningBody" className={styles.popup}>
				<div className={styles.popupHeader} style={background}>
					<span>Предупреждение</span>
					<a className={styles.close} >&times;</a>
				</div>
				<div className={styles.content}>
					{warningText}
				</div>
			</div>
		</div>
	)

}

export default Popup;



// WEBPACK FOOTER //
// ./src/react/ui/features/Popup/Popup.jsx